import { render, staticRenderFns } from "./remarksModal.vue?vue&type=template&id=9472e366&scoped=true"
import script from "./remarksModal.vue?vue&type=script&lang=js"
export * from "./remarksModal.vue?vue&type=script&lang=js"
import style0 from "./remarksModal.vue?vue&type=style&index=0&id=9472e366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9472e366",
  null
  
)

export default component.exports